import {
  OrderDesignHistoryRecord,
  OrderDesignStatusEnum,
} from "@jasper/client-models";
import { Tabs, Text, ThemeIcon, Timeline } from "@mantine/core";
import {
  IconCheck,
  IconPencil,
  IconUpload,
  IconUserSearch,
  IconX,
} from "@tabler/icons-react";

interface Props {
  history: OrderDesignHistoryRecord[];
  tab?: string;
}

const getRecordLabel = (record: OrderDesignHistoryRecord) => {
  switch (record.status) {
    case OrderDesignStatusEnum.REQUESTED:
      return "Design requested";
    case OrderDesignStatusEnum.DRAFT:
      return "Design opened by provider";
    case OrderDesignStatusEnum.OPENED:
      return "Design uploaded";
    case OrderDesignStatusEnum.VALIDATED:
      return "Design validated by practitioner";
    case OrderDesignStatusEnum.AUTOMATICALLY_VALIDATED:
      return "Design automatically validated";
    case OrderDesignStatusEnum.REJECTED:
      return "Design rejected by practitioner";
    default:
      return record.status;
  }
};

const getRecordIcon = (record: OrderDesignHistoryRecord) => {
  switch (record.status) {
    case OrderDesignStatusEnum.REQUESTED:
      return <IconUserSearch />;
    case OrderDesignStatusEnum.DRAFT:
      return <IconPencil />;
    case OrderDesignStatusEnum.OPENED:
      return <IconUpload />;
    case OrderDesignStatusEnum.VALIDATED:
    case OrderDesignStatusEnum.AUTOMATICALLY_VALIDATED:
      return <IconCheck />;
    case OrderDesignStatusEnum.REJECTED:
      return <IconX />;
  }
};

const getRecordColor = (record: OrderDesignHistoryRecord) => {
  switch (record.status) {
    case OrderDesignStatusEnum.REQUESTED:
    case OrderDesignStatusEnum.DRAFT:
      return "gray";
    case OrderDesignStatusEnum.OPENED:
      return "blue";
    case OrderDesignStatusEnum.VALIDATED:
    case OrderDesignStatusEnum.AUTOMATICALLY_VALIDATED:
      return "green";
    case OrderDesignStatusEnum.REJECTED:
      return "red";
    default:
      return "gray";
  }
};

export const OrderDesignHistoryTab = ({ history, tab = "history" }: Props) => {
  return (
    <Tabs.Panel value={tab} py="xs" px="md">
      <Timeline bulletSize={32}>
        {history.map(record => (
          <Timeline.Item
            key={record.id}
            title={getRecordLabel(record)}
            bullet={
              <ThemeIcon color={getRecordColor(record)} radius="lg">
                {getRecordIcon(record)}
              </ThemeIcon>
            }
            lineVariant="dashed"
          >
            <Text size="xs">{new Date(record.changedAt).toLocaleString()}</Text>
          </Timeline.Item>
        ))}
      </Timeline>
    </Tabs.Panel>
  );
};
